<template>
    <div class="" v-if="wantsPickup">
        <slot><p><strong>Abholadresse</strong></p></slot>
        <p>
            {{ subscription.subsidiary.name }}<br>
            {{ vehicle.address.street }} {{vehicle.address.house_number}}<br>
            {{ vehicle.address.postal_code }} {{ vehicle.address.city }}
        </p>
    </div>
</template>

<script>
    export default {
        name: "PickupAddress",
        props: {
            vehicle: {
                type: Object,
                required: true
            },
            subscription: {
                type: Object,
                required: true
            }
        },
        computed: {
            deliveryAddressObject() {
                if(this.subscription.delivery_address !== null){
                    return this.subscription.delivery_address;
                } else {
                    if (typeof this.subscription.details.deliveryAddress !== 'undefined') {
                        return this.subscription.details.deliveryAddress;
                    } else {
                        return this.subscription.details.address;
                    }
                }
            },
            wantsPickup(){
                if(this.subscription.details !== null){
                    return this.subscription.details.deliveryMethod === 'pickup';
                }
                return false;
            }

        }
    }
</script>

<style scoped>

</style>
